/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import { RegularText } from '../StyledTypography';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledRegularList = RegularText.withComponent('ul').extend`
  margin-top: 0;
  margin-bottom: 0;
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledRegularList/index.js